import IpsPagination from './IpsPagination.vue';
import '../../../styles/custom.scss';

export default IpsPagination;
